import React, { useEffect } from 'react';
import '../styles/Ediciones.css';
import '../styles/Inicio.css';
import welcomeImage from '../assets/images/edicion1.jpg';
import Votaciones from './Votaciones';
import Candidatura from './Candidatura';
import { ScrollToTop } from './ScrollToTop';
import { FaInstagram, FaCalendarAlt, FaMapMarkerAlt } from 'react-icons/fa';
import ScrollReveal from "scrollreveal";

const Edicion1 = () => {
    const sr = ScrollReveal({
        origin: "top",
        distance: "60px",
        duration: 1500,
        delay: 0,
        reset: false,
    });

    const handleScroll = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    useEffect(() => {
        sr.reveal(
            `.text-content, .image-container, .tituloP, .contacto-section, action-buttons, votaciones-section, candidatura-section`
        );
        sr.reveal(`.info-text`, { origin: "left", delay: 800 });
        sr.reveal(`.map-info-container`, { origin: "right", delay: 800 });

    }, [sr]);

    return (
        <div className="main-content">

            {/* Hero Section */}
            <section id="hero-section" className="hero-edicion full-screen">
                <div className="text-content">
                    <h1 className="tituloG">1ª Edición</h1>

                    {/* Event Date Container */}
                    <div className="event-info">
                        <FaCalendarAlt className="icon" />
                        <p className="event-date">¡Próximamente!</p>
                    </div>

                    {/* Location Container */}
                    <div className="event-info">
                        <FaMapMarkerAlt className="icon" />
                        <div>
                            <p className="event-location">Calle Cebreros, 2</p>
                            <p className="event-location">Latina 28011, Madrid</p>
                        </div>
                    </div>

                    <button className="btn-scroll" onClick={() => handleScroll('info-section')}>
                        Saber más
                        <span className="arrow"></span>
                    </button>
                </div>
                <div className="image-container">
                    <img src={welcomeImage} alt="Evento Alayi" className="event-image" />
                </div>
            </section>

            {/* Info Section */}
            <section id="info-section" className="info-section">
                <div className="tituloP-container">
                    <h1 className="tituloP">Sobre el evento</h1>
                </div>
                <div className="info-container">

                    {/* Text Column */}
                    <div className="info-text">
                        <h4>¡Bienvenidxs!</h4>
                        <p>
                            La motivación para la creación de esta primera edición de Alayi Events fue darme cuenta de que, en España, el maravilloso país en el que nací y crecí, hay cosas que no cambian por mucho que pasen los años, y es que es necesario una mayor exposición de la comunidad afrodescendiente en premios, eventos y galas.
                        </p>
                        <p>
                            Y es aquí cuando Alayi Events, en su primera edición, creará una gala para reconocer y premiar el talento, en especial, el que tiene la comunidad afrodescendiente en España.
                        </p>
                        <p>¡Os esperamos!</p>
                        <a href="https://www.instagram.com/alayi_events" target="_blank" rel="noopener noreferrer" className="social-icon">
                            <FaInstagram className="ig-icon" />
                        </a>
                    </div>

                    {/* Map y Localizacion */}
                    <div className="map-info-container">
                        <div className="location-header">
                            <span className="location-text">
                                <FaMapMarkerAlt className="location-icon" />
                                Ubicación del evento:
                            </span>
                            <p className="event-address">Calle Cebreros, 2, Latina 28011, Madrid</p>
                        </div>

                        {/* Map Container */}
                        <div className="map-container">
                            <iframe
                                title="Ubicación del Evento"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3036.763110915946!2d-3.7457994846056645!3d40.39872357936524!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd422871d0375cfd%3A0x63e64f2557a02cf2!2sC.%20de%20Cebreros%2C%202%2C%2028011%20Madrid!5e0!3m2!1ses!2ses!4v1684330486317!5m2!1ses!2ses"
                                width="100%"
                                height="300"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                            ></iframe>
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="action-buttons">
                    <button className="btn-scroll">Adquirir entrada</button>
                    <button className="btn-scroll" onClick={() => handleScroll('votaciones-section')}>
                        Votar candidato
                        <span className="arrow"></span>
                    </button>
                    <button className="btn-scroll" onClick={() => handleScroll('candidatura-section')}>
                        Enviar candidatura
                        <span className="arrow"></span>
                    </button>
                </div>
            </section>

            {/* Votaciones Section */}
            <section id="votaciones-section" className="votaciones-section">
                <div className="tituloP-container">
                    <h1 className="tituloP">Votaciones</h1>
                </div>
                <Votaciones />
            </section>

            {/* Candidatura Section */}
            <section id="candidatura-section" className="candidatura-section">
                <div className="tituloP-container">
                    <h1 className="tituloP">Envía tu candidatura</h1>
                </div>
                <div className='form-container-padre'>
                    <Candidatura />
                </div>
            </section>

            {/* Botón de Scroll */}
            <ScrollToTop />
        </div>
    );
};

export default Edicion1;